import { FC } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SportName from "./SportName";
import { SPORT_LISTS } from "./config";
import { Button } from "./styled";
import NumberOfMatch from "./NumberOfMatch";
import useSportsBar from "./useSportsBar";
import SportBarService from "../../services/sportBar";
import query from "../../query";
import {
  DEFAULT_PROVIDER,
  isSabaComboDisabled,
} from "../../utils/providerQuery";

const sportBarService = new SportBarService();
const accordionId = sportBarService.getAccordionId();
// const buttonId = sportBarService.getButtonId();

const SportsBarDesktop: FC = () => {
  const { numberOfMatchType } = useSportsBar();
  const providerQuery = query.provider();
  const pvd = useQuery(providerQuery.key, providerQuery.queryFn, {
    refetchOnMount: false,
    keepPreviousData: true,
  });
  const navigate = useNavigate();
  const { t } = useTranslation();
  const selectedProvider = pvd.data ?? DEFAULT_PROVIDER;
  const isSabaFootballComboDisabled = isSabaComboDisabled(
    selectedProvider,
    "football",
  );

  return (
    <div>
      <Button
        // id={buttonId}
        // aria-expanded="true"
        className="p-3 flex w-full justify-items-center"
        // className="p-3 flex w-full justify-items-center accordion-button"
        // data-bs-target={`#${accordionId}`}
        // data-bs-toggle="collapse"
        // type="button"
        // aria-controls={accordionId}
        noBorder
      >
        <SportName
          iconSrc={`${process.env.PUBLIC_URL}/allSport.png`}
          name={t("List of Sports")}
        />
      </Button>
      <ul
        className="accordion collapse show accordion-flush"
        id={accordionId}
      >
        {SPORT_LISTS.map((sport) => {
          const collapseId = `collapse-${sport.name}`;
          const headingId = `heading-${sport.name}`;
          const hasCollapse = Boolean(sport?.collapse?.length);
          const isComboDisabled =
            sport.routeTo === "combo-step" && isSabaFootballComboDisabled;
          const isComingSoon = sport.isComingSoon || isComboDisabled;

          return (
            <li key={sport.name} className="text-left text-sm accordion-item">
              {hasCollapse ? (
                <>
                  <Button
                    aria-expanded="false"
                    className="p-3 collapsed flex w-full justify-items-center accordion-button"
                    data-bs-target={`#${collapseId}`}
                    data-bs-toggle="collapse"
                    id={headingId}
                    type="button"
                    aria-controls={collapseId}
                    marginArrow="8px"
                  >
                    <SportName
                      iconSrc={sport.icon}
                      name={t(sport.name.replace("-", " "))}
                    />
                    <NumberOfMatch
                      className="ml-auto"
                      isLoading={numberOfMatchType.isLoading}
                      data={numberOfMatchType.data}
                      keyData={sport.keyData}
                    />
                  </Button>
                  <ul
                    aria-labelledby={headingId}
                    className="collapse accordion-collapse pl-7"
                    data-bs-parent={`#${accordionId}`}
                    id={collapseId}
                  >
                    {sport?.collapse?.map((item) => (
                      <li key={item.name}>
                        <Button
                          className="flex p-3 w-full"
                          onClick={() => {
                            navigate(`/${sport.routeTo}/${item.routeTo}`);
                          }}
                        >
                          <div>{t(item.name)}</div>
                          <NumberOfMatch
                            className="ml-auto mr-6"
                            isLoading={numberOfMatchType.isLoading}
                            data={numberOfMatchType.data}
                            keyData={item.keyData}
                          />
                        </Button>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Button
                  className="p-3 flex w-full"
                  disabled={!sport.routeTo || isComboDisabled}
                  onClick={() => {
                    navigate(`/${sport.routeTo}`);
                  }}
                >
                  <SportName iconSrc={sport.icon} name={t(sport.name)} />
                  {isComingSoon ? (
                    <div className="ml-auto bg-gray-200 rounded-md p-1 text-xs">
                      {t("Coming Soon")}
                    </div>
                  ) : (
                    <NumberOfMatch
                      className="ml-auto mr-6"
                      isLoading={numberOfMatchType.isLoading}
                      data={numberOfMatchType.data}
                      keyData={sport.keyData}
                    />
                  )}
                </Button>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SportsBarDesktop;
